import type { BaseResponse } from 'api/api.types';
import { api } from '../../../api/api';
import type { LoginRequestDto, LoginResponseDto } from './dtos/login.dto';

export const fetchLogin = async (body: LoginRequestDto) => {
  const { data } = await api.post<BaseResponse<LoginResponseDto>>('/user/login', body);
  return data.data;
};
